import React from "react";
import { Youtube } from "lucide-react";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="bg-cream2 px-6 py-16 lg:px-12" data-testid="footer">
    <div className="mx-auto max-w-7xl">
      <div className="flex flex-col items-start gap-10 md:flex-row md:items-center md:justify-between">
        <Logo height={64} />
        <a
          href="https://www.youtube.com/@Universaflow"
          target="_blank"
          rel="noopener noreferrer"
          className="flex max-w-xl items-start gap-2 text-sm leading-relaxed text-ink-soft transition-colors duration-300 hover:text-ink"
          data-testid="footer-youtube-link"
        >
          <Youtube size={18} strokeWidth={1.5} className="mt-0.5 shrink-0 text-terracotta" aria-hidden="true" />
          <span>
            Join our channel — 1,000+ people already on this journey of conscious and vibrational
            transformation
            <span className="ml-1.5 text-terracotta">→</span>
          </span>
        </a>
      </div>

      <div className="mt-10 border-t border-[rgba(43,38,32,0.1)] pt-6">
        <p className="max-w-xl text-xs leading-relaxed text-ink-soft" data-testid="footer-disclaimer">
          Universa Flow is a wellness and personal development product. It does not replace medical,
          psychological, or therapeutic advice.
        </p>
      </div>

      <div className="mt-6">
        <p className="text-xs tracking-wide text-ink-soft">
          © {new Date().getFullYear()} Universa Flow. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);
